// libraries.
import { FetchBaseQueryError } from '@reduxjs/toolkit/query';
import { apiOrchestratorPricingCommittee } from '@store/apiSlices/apiSlices';

// interfaces.
import { ModelError } from '@store/apiSlices/interfaces/interfaces';
import {
  IOrchestratorPricingCommitteeResponse,
  IOrchestratorPricingCommittee,
} from '../../interfaces/interfaces';
import { CountryCode } from '@domains/country';

export const orchestratorPricingCommittee =
  apiOrchestratorPricingCommittee.injectEndpoints({
    endpoints: builder => ({
      getCurrentOrchestrator: builder.query<
        IOrchestratorPricingCommittee,
        { country?: CountryCode; nid: string; workflow_alias?: string }
      >({
        query: params => ({
          url: `/retrieve-current-orchestrator`,
          params,
        }),
        transformErrorResponse: (error: FetchBaseQueryError) => {
          const modelError: ModelError = {
            errorStatus: error.status,
            messageFromServer: (error.data as any)?.message,
            serviceErrorName: 'getCurrentOrchestrator',
          };
          return modelError;
        },
        transformResponse: (
          response: IOrchestratorPricingCommitteeResponse
        ): IOrchestratorPricingCommittee => {
          return response.orchestrator;
        },
        providesTags: (result, error, { country, nid, workflow_alias }) => [
          {
            type: 'CurrentOrchestrator' as const,
            id: `${country ?? 'all'}:${nid ?? 'current'}:${workflow_alias ?? 'all'}`,
          },
        ],
      }),
    }),
  });

export const { useGetCurrentOrchestratorQuery } = orchestratorPricingCommittee;
